import { endpoints } from "@/configs/Settings";
import { HTTPResponseStatus } from "@/utils/enum";
import { useAuth } from "@/utils/useAuth";
import { useAxios } from "@/utils/useAxios";

/**
 * Remove um modelo de prescrição do servidor FHIR
 * 
 * @param id - ID do QuestionnaireResponse a remover
 * @returns void
 */
export async function DeletePrescriptionTemplate(id: string) {
  const bearerToken = await useAuth.getUserToken();
  const headers = {
    Accept: "*/*",
    Authorization: bearerToken,
    "Content-Type": "application/fhir+json",
  };

  const response = await useAxios
    .delete(`${endpoints.ADMFHIR}/QuestionnaireResponse/${id}`, {
      headers,
      timeout: 20000,
    })
    .then((response) => {
      // DELETE pode retornar 200 ou 204
      if (
        response.status !== HTTPResponseStatus.Success &&
        response.status !== HTTPResponseStatus.NoContent
      ) {
        throw new Error(`DeletePrescriptionTemplate: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("DeletePrescriptionTemplate Error:", error);
      throw new Error(
        `Erro ao excluir modelo: ${error?.response?.status || "Desconhecido"}`
      );
    });

  return response;
}
